<template>
  <transition name="global-notice-fade">
    <div class="global-notice" v-if="visible">
      <div class="global-notice__mask"></div>
      <div class="global-notice__dialog" role="dialog" aria-modal="true" aria-labelledby="globalNoticeTitle">
        <button class="global-notice__close" type="button" aria-label="关闭通知" @click="closeNotice">×</button>
        <div class="global-notice__header">
          <span id="globalNoticeTitle">重要通知</span>
        </div>
        <div class="global-notice__body">
          <p>尊敬的用户，平台将于2026年5月21日上午9:00进行维护升级，预计持续时间3小时，期间网络服务将受到影响，感谢您的理解与支持。</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
const NOTICE_CLOSE_TIME_KEY = 'globalNoticeClosedAt'
const NOTICE_HIDE_DURATION = 60 * 60 * 1000

export default {
  name: 'GlobalNotice',
  data() {
    return {
      visible: false,
      timer: null
    }
  },
  mounted() {
    this.updateVisible()
  },
  beforeDestroy() {
    this.clearTimer()
  },
  methods: {
    updateVisible() {
      this.clearTimer()

      const closedAt = Number(window.localStorage.getItem(NOTICE_CLOSE_TIME_KEY))
      const now = Date.now()

      if (!closedAt || now - closedAt >= NOTICE_HIDE_DURATION) {
        this.visible = true
        return
      }

      this.visible = false
      this.timer = window.setTimeout(() => {
        this.visible = true
      }, NOTICE_HIDE_DURATION - (now - closedAt))
    },
    closeNotice() {
      window.localStorage.setItem(NOTICE_CLOSE_TIME_KEY, String(Date.now()))
      this.visible = false
      this.updateVisible()
    },
    clearTimer() {
      if (this.timer) {
        window.clearTimeout(this.timer)
        this.timer = null
      }
    }
  }
}
</script>

<style scoped>
.global-notice {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3000;
}

.global-notice__mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.45);
}

.global-notice__dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 420px;
  max-width: calc(100% - 32px);
  transform: translate(-50%, -50%);
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

.global-notice__close {
  position: absolute;
  top: 12px;
  right: 14px;
  width: 28px;
  height: 28px;
  border: 0;
  background: transparent;
  color: #999;
  cursor: pointer;
  font-size: 24px;
  line-height: 28px;
}

.global-notice__close:hover {
  color: #333;
}

.global-notice__header {
  padding: 18px 48px 14px 24px;
  border-bottom: 1px solid #eee;
  color: #222;
  font-size: 18px;
  font-weight: 600;
}

.global-notice__body {
  padding: 22px 24px 26px;
  color: #555;
  font-size: 14px;
  line-height: 1.8;
}

.global-notice__body p {
  margin: 0;
}

.global-notice-fade-enter-active,
.global-notice-fade-leave-active {
  transition: opacity 0.2s ease;
}

.global-notice-fade-enter,
.global-notice-fade-leave-to {
  opacity: 0;
}
</style>
